import { render, staticRenderFns } from "./LegacyMeasurementsPage.vue?vue&type=template&id=6fb11b3a"
import script from "./LegacyMeasurementsPage.vue?vue&type=script&lang=ts"
export * from "./LegacyMeasurementsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports